var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.3373 17.4791V14.3467C17.3373 14.2214 17.2745 14.0961 17.2117 14.0021L3.80039 0.595268C3.70616 0.501295 3.58053 0.469971 3.4549 0.469971H0.314082C0.157041 0.469971 0.0314082 0.595268 0.0314082 0.75189V3.66506C0.0314082 3.79036 0.0942246 3.91565 0.157041 4.00963L4.96249 8.80226C5.08812 8.92756 5.08812 9.08418 4.96249 9.20948L0.0942245 14.0648C0.0314081 14.1274 0 14.1901 0 14.2527V17.4478C0 17.6044 0.125633 17.7297 0.282673 17.7297H5.55925C5.71629 17.7297 5.84192 17.6044 5.84192 17.4478V15.5683C5.84192 15.5057 5.87333 15.4117 5.93614 15.3804L8.54302 12.7805C8.66865 12.6552 8.82569 12.6552 8.95133 12.7805L13.7882 17.6044C13.8824 17.6984 14.008 17.7297 14.1337 17.7297H17.0546C17.2117 17.761 17.3373 17.6357 17.3373 17.4791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2709 4.60479H12.9092C13.0662 4.60479 13.1918 4.73009 13.1918 4.88671V7.51796C13.1918 7.76855 13.5059 7.89385 13.663 7.7059L17.2749 4.1036C17.3377 4.04095 17.3691 3.9783 17.3691 3.91565V0.75189C17.3691 0.595268 17.2435 0.469971 17.0865 0.469971H13.8828C13.82 0.469971 13.7258 0.501295 13.6944 0.563944L10.0824 4.13492C9.89399 4.29155 10.0196 4.60479 10.2709 4.60479Z",
    fill: "#EE7A30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXverse);
export default __webpack_public_path__ + "static/media/xverse.50cc507fb48f56c286a4b4fed4db49d0.svg";
export { ForwardRef as ReactComponent };